<template>
	<section class="service">
		<span ref="ball" :style="{top: top +'px', left: left +'px'}" @click="showDivPopup" @touchstart="touchStart"
			@mousedown="touchStart"></span>
		<div class="ser-con" v-show="showDiv">
			<div class="ser-cons">
				<i @click="showDiv=false"></i>
				<h3>Customer Services:</h3>
				<a href="tel:09270023183">09270023183 <img src="../assets/img/tel.png" /></a>
				<h3>Our E-mail address:</h3>
				<a>hello@funpera.com</a>
				<h3>Complaint & Suggestions:</h3>
				<a>adminsup@funpera.com</a>
			</div>
		</div>
	</section>
</template>
<script>
	export default {
		data() {
			return {
				showDiv: false,
				ball: null,
				top: 0,
				left: 0,
				startX: 0,
				startY: 0,
				defaultLeft: 0,
				defaultTop: 0
			}
		},
		mounted: function() {
			var self = this;
			self.ball = self.$refs.ball;
			if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
				self.top = window.innerHeight - self.ball.offsetHeight - 100;
				self.left = window.innerWidth - self.ball.offsetWidth - 18;
			}else {
				self.top = 300;
				self.left = 800
			}
		},
		methods: {
			//点击
			touchStart(e) {
				let self = this;
				self.defaultLeft = self.ball.offsetLeft;
				self.defaultTop = self.ball.offsetTop;
				self.startX = e.clientX || e.touches[0].pageX;
				self.startY = e.clientY || e.touches[0].pageY;
				self.ball.addEventListener('touchmove', self.touchMove);
				self.ball.addEventListener('mousemove', self.touchMove);
				self.ball.addEventListener('mouseup', self.mouseEnd);
			},

			//滑动
			touchMove(e) {
				let self = this;
				let endX = e.clientX || e.touches[0].pageX;
				let endY = e.clientY || e.touches[0].pageY;
				let moveX = endX - self.startX;
				let moveY = endY - self.startY;
				self.top = self.defaultTop + moveY;
				self.left = self.defaultLeft + moveX;
				self.ball.addEventListener('mouseup', self.mouseEnd);
				self.ball.addEventListener('touchend', self.mouseEnd);
			},

			//移动结束
			mouseEnd() {
				var self = this;
				self.$refs.ball.removeEventListener('mousemove', self.touchMove);
				self.$refs.ball.removeEventListener('touchmove', self.touchMove);
				self.$refs.ball.removeEventListener('mouseup', self.mouseEnd);
				self.$refs.ball.removeEventListener('touchend', self.mouseEnd);
			},

			showDivPopup(e) {
				let endX = e.clientX || e.touches[0].pageX;
				let endY = e.clientY || e.touches[0].pageY;
				if (endX == this.startX && endY == this.startY) { //位置没有变化
					this.showDiv = true;
				}
			}
		}
	}
</script>

<style scoped>
	.service span {
		width: 0.6rem;
		height: 0.6rem;
		background: url("../assets/img/service.png") no-repeat;
		background-size: cover;
		position: fixed;
		bottom: 1.5rem;
	}

	.ser-con {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.3);
		position: fixed;
		top: 0;
		left: 0;
	}

	.ser-cons {
		width: 6.5rem;
		padding: 0.6rem 0;
		background-color: #FFF;
		border-radius: 0.1rem;
		position: absolute;
		top: 50%;
		margin-top: -3.8rem;
		left: 0.5rem;
	}

	.ser-con h3 {
		height: 0.88rem;
		line-height: 0.88rem;
		font-size: 0.3rem;
		font-weight: normal;
		color: #333;
		margin-left: 1rem;
	}

	.ser-con a {
		width: 5.22rem;
		height: 0.86rem;
		line-height: 0.86rem;
		padding-left: 0.6rem;
		font-size: 0.32rem;
		color: #FFF;
		background-color: #ED7D31;
		border-radius: 0.02rem;
		display: block;
		margin: 0 auto;
	}

	.ser-con img {
		width: 0.52rem;
		height: 0.52rem;
		float: right;
		margin: 0.17rem 0.4rem 0 0;
	}

	.ser-con i {
		width: 0.5rem;
		height: 0.5rem;
		background: url("../assets/img/close.png") no-repeat center;
		background-size: 0.28rem 0.27rem;
		position: absolute;
		top: 0.25rem;
		right: 0.25rem;
	}
</style>
